import {
  anUpdateInsightStatusInProgressEnabled,
  mockUpdateInsightInProgressStatusOperationMutation,
} from '__generated__';

export const ERROR_MESSAGE = 'The "In Progress" status cannot be disabled';

export const updateInsightInProgressMutation_error =
  mockUpdateInsightInProgressStatusOperationMutation((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.errors([
        {
          message: ERROR_MESSAGE,
        },
      ])
    );
  });

export const handlers = [
  mockUpdateInsightInProgressStatusOperationMutation((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Mutation',
        updateInsightStatusInProgressEnabled:
          anUpdateInsightStatusInProgressEnabled({ ok: true }),
      })
    );
  }),
];
